import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import capabilities from "../data/capabilities.json";

const crumbStyle = {
  fontFamily: "var(--font-mono)",
  fontSize: "0.72rem",
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: "var(--text-muted)",
  marginBottom: "1.5rem",
};

export default function Capability({ cap }) {
  if (!cap) return null;
  const others = capabilities.filter((c) => c.slug !== cap.slug);

  return (
    <>
      <Nav />
      <main>
        <header id="top" className="hero">
          <div className="wrap hero-inner">
            <nav style={crumbStyle} aria-label="Breadcrumb">
              <a href="/">Home</a> &nbsp;/&nbsp;
              <a href="/#capabilities">Capabilities</a> &nbsp;/&nbsp;
              <span style={{ color: "var(--signal)" }}>{cap.name}</span>
            </nav>
            <span className="eyebrow">§ Capability {cap.number}</span>
            <h1 className="display-1">{cap.name}</h1>
            <p className="lede">{cap.tagline}</p>
            <div className="hero-ctas">
              <a className="btn btn--solid" href="/#contact">
                Start a project
                <span className="btn-arrow" aria-hidden="true">→</span>
              </a>
              <a className="btn btn--ghost" href="/#capabilities">
                All capabilities
              </a>
            </div>
          </div>
        </header>

        <section className="section">
          <div className="wrap">
            <div className="about-grid">
              <div className="about-body">
                {cap.overview.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
                <div className="tag-row" style={{ marginTop: "2rem" }}>
                  {cap.tags.map((t, j) => (
                    <span key={j} className="tag">{t}</span>
                  ))}
                </div>
              </div>

              <div className="pillars">
                {cap.build.map((b, i) => (
                  <div key={i} className="pillar">
                    <div className="pillar-marker">{String(i + 1).padStart(2, "0")}</div>
                    <div>
                      <div className="pillar-label">{b.label}</div>
                      <div className="pillar-text">{b.text}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="wrap">
            <div className="section-head">
              <span className="eyebrow">§ In practice</span>
              <h2 className="display-2">{cap.outcome}</h2>
            </div>
          </div>
        </section>

        {cap.relatedPosts && cap.relatedPosts.length > 0 && (
          <section className="section">
            <div className="wrap">
              <div className="section-head">
                <span className="eyebrow">§ Further reading</span>
                <h2 className="display-2">Field notes from this practice.</h2>
              </div>
              <ul className="further-reading">
                {cap.relatedPosts.map((p) => (
                  <li key={p.slug}>
                    <a href={`/blog/post/${p.slug}`}>
                      {p.title}
                      <span aria-hidden="true"> →</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        )}

        <section id="capabilities" className="section">
          <div className="wrap">
            <div className="section-head">
              <span className="eyebrow">§ Other capabilities</span>
              <h2 className="display-2">Three more practice areas, each backed by deployed work.</h2>
            </div>
            <div className="capability-list">
              {others.map((c) => (
                <a key={c.slug} className="capability" href={`/capabilities/${c.slug}`} style={{ textDecoration: "none", color: "inherit" }}>
                  <div className="capability-number">§ {c.number}</div>
                  <h3 className="capability-name">{c.name}</h3>
                  <p className="capability-text">{c.tagline}</p>
                  <div className="tag-row">
                    {c.tags.slice(0, 3).map((t, j) => (
                      <span key={j} className="tag">{t}</span>
                    ))}
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
